export const integrationsConstants = {
    // BAMBOO
    GET_BAMBOO_INTEGRATIONS_REQUEST: "GET_BAMBOO_INTEGRATIONS_REQUEST",
    GET_BAMBOO_INTEGRATIONS_SUCCESS: "GET_BAMBOO_INTEGRATIONS_SUCCESS",
    GET_BAMBOO_INTEGRATIONS_FAILURE: "GET_BAMBOO_INTEGRATIONS_FAILURE",

    ADD_BAMBOO_INTEGRATION_REQUEST: "ADD_BAMBOO_INTEGRATION_REQUEST",
    ADD_BAMBOO_INTEGRATION_SUCCESS: "ADD_BAMBOO_INTEGRATION_SUCCESS",
    ADD_BAMBOO_INTEGRATION_FAILURE: "ADD_BAMBOO_INTEGRATION_FAILURE",

    DELETE_BAMBOO_INTEGRATION_REQUEST: "DELETE_BAMBOO_INTEGRATION_REQUEST",
    DELETE_BAMBOO_INTEGRATION_SUCCESS: "DELETE_BAMBOO_INTEGRATION_SUCCESS",
    DELETE_BAMBOO_INTEGRATION_FAILURE: "DELETE_BAMBOO_INTEGRATION_FAILURE",

    TOGGLE_DELETE_BAMBOO_INTEGRATION: "TOGGLE_DELETE_BAMBOO_INTEGRATION",
    TOGGLE_SHOW_BAMBOO_DATEV_SETTINGS: "TOGGLE_SHOW_BAMBOO_DATEV_SETTINGS",
    TOGGLE_SHOW_BAMBOO_DATEV_SETTINGS_REQUEST: "TOGGLE_SHOW_BAMBOO_DATEV_SETTINGS_REQUEST",
    TOGGLE_BAMBOO_RESULT_OPTIONS: "TOGGLE_BAMBOO_RESULT_OPTIONS",

    RECEIVE_BAMBOO_RESULT_OPTIONS_REQUEST: "RECEIVE_BAMBOO_RESULT_OPTIONS_REQUEST",
    RECEIVE_BAMBOO_RESULT_OPTIONS_SUCCESS: "RECEIVE_BAMBOO_RESULT_OPTIONS_SUCCESS",
    RECEIVE_BAMBOO_RESULT_OPTIONS_FAILURE: "RECEIVE_BAMBOO_RESULT_OPTIONS_FAILURE",

    SAVE_BAMBOO_DATEV_SETTINGS_REQUEST: "SAVE_BAMBOO_DATEV_SETTINGS_REQUEST",
    SAVE_BAMBOO_DATEV_SETTINGS_SUCCESS: "SAVE_BAMBOO_DATEV_SETTINGS_SUCCESS",
    SAVE_BAMBOO_DATEV_SETTINGS_FAILURE: "SAVE_BAMBOO_DATEV_SETTINGS_FAILURE",

    SAVE_BAMBOO_CONFIGURATION_REQUEST: "SAVE_BAMBOO_CONFIGURATION_REQUEST",
    SAVE_BAMBOO_CONFIGURATION_SUCCESS: "SAVE_BAMBOO_CONFIGURATION_SUCCESS",
    SAVE_BAMBOO_CONFIGURATION_FAILURE: "SAVE_BAMBOO_CONFIGURATION_FAILURE",

    RETRIEVE_BAMBOO_RESULT_REQUEST: "RETRIEVE_BAMBOO_RESULT_REQUEST",
    RETRIEVE_BAMBOO_RESULT_SUCCESS: "RETRIEVE_BAMBOO_RESULT_SUCCESS",
    RETRIEVE_BAMBOO_RESULT_FAILURE: "RETRIEVE_BAMBOO_RESULT_FAILURE",

    TRANSFER_BAMBOO_TO_HR_REPORT_REQUEST: "TRANSFER_BAMBOO_TO_HR_REPORT_REQUEST",
    TRANSFER_BAMBOO_TO_HR_REPORT_SUCCESS: "TRANSFER_BAMBOO_TO_HR_REPORT_SUCCESS",
    TRANSFER_BAMBOO_TO_HR_REPORT_FAILURE: "TRANSFER_BAMBOO_TO_HR_REPORT_FAILURE",

    TOGGLE_BAMBOO_DELETION_MODAL: "TOGGLE_BAMBOO_DELETION_MODAL",

    EXPORT_DATEV_NEW_EMPLOYEES_REQUEST: "EXPORT_DATEV_NEW_EMPLOYEES_REQUEST",
    EXPORT_DATEV_NEW_EMPLOYEES_SUCCESS: "EXPORT_DATEV_NEW_EMPLOYEES_SUCCESS",
    EXPORT_DATEV_NEW_EMPLOYEES_FAILURE: "EXPORT_DATEV_NEW_EMPLOYEES_FAILURE",

    // HR
    GET_HR_REPORTS_REQUEST: "GET_HR_REPORTS_REQUEST",
    GET_HR_REPORTS_SUCCESS: "GET_HR_REPORTS_SUCCESS",
    GET_HR_REPORTS_FAILURE: "GET_HR_REPORTS_FAILURE",

    SAVE_COMMENT_ON_CHANGE_REQUEST: "SAVE_COMMENT_ON_CHANGE_REQUEST",
    SAVE_COMMENT_ON_CHANGE_SUCCESS: "SAVE_COMMENT_ON_CHANGE_SUCCESS",
    SAVE_COMMENT_ON_CHANGE_FAILURE: "SAVE_COMMENT_ON_CHANGE_FAILURE",
    CHANGE_STATUS_ON_CHANGE_REQUEST: "CHANGE_STATUS_ON_CHANGE_REQUEST",

    CHANGE_STATUS_ON_CHANGE_SUCCESS: "CHANGE_STATUS_ON_CHANGE_SUCCESS",
    CHANGE_STATUS_ON_CHANGE_FAILURE: "CHANGE_STATUS_ON_CHANGE_FAILURE",
    APPROVE_ALL_CHANGES_ON_REPORT_REQUEST: "APPROVE_ALL_CHANGES_ON_REPORT_REQUEST",

    APPROVE_ALL_CHANGES_ON_REPORT_SUCCESS: "APPROVE_ALL_CHANGES_ON_REPORT_SUCCESS",
    APPROVE_ALL_CHANGES_ON_REPORT_FAILURE: "APPROVE_ALL_CHANGES_ON_REPORT_FAILURE",
    TOGGLE_HR_REPORT_DELETE_MODAL: "TOGGLE_HR_REPORT_DELETE_MODAL",

    DELETE_HR_REPORT_REQUEST: "DELETE_HR_REPORT_REQUEST",

    DELETE_HR_REPORT_SUCCESS: "DELETE_HR_REPORT_SUCCESS",
    DELETE_HR_REPORT_FAILURE: "DELETE_HR_REPORT_FAILURE",

    GET_SEARCH_DATA_REQUEST: "GET_SEARCH_DATA_REQUEST",

    GET_SEARCH_DATA_SUCCESS: "GET_SEARCH_DATA_SUCCESS",
    GET_SEARCH_DATA_FAILURE: "GET_SEARCH_DATA_FAILURE",
    CLOSE_REPORT_REQUEST: "CLOSE_REPORT_REQUEST",

    CLOSE_REPORT_SUCCESS: "CLOSE_REPORT_SUCCESS",
    CLOSE_REPORT_FAILURE: "CLOSE_REPORT_FAILURE",
    CONFIRM_HR_REPORT_REQUEST: "CONFIRM_HR_REPORT_REQUEST",

    CONFIRM_HR_REPORT_SUCCESS: "CONFIRM_HR_REPORT_SUCCESS",
    CONFIRM_HR_REPORT_FAILURE: "CONFIRM_HR_REPORT_FAILURE",
    GET_HR_REPORT_REQUEST: "GET_HR_REPORT_REQUEST",

    GET_HR_REPORT_SUCCESS: "GET_HR_REPORT_SUCCESS",
    GET_HR_REPORT_FAILURE: "GET_HR_REPORT_FAILURE",
    DELETE_HR_CHANGE_COMMENT_REQUEST: "DELETE_HR_CHANGE_COMMENT_REQUEST",

    DELETE_HR_CHANGE_COMMENT_SUCCESS: "DELETE_HR_CHANGE_COMMENT_SUCCESS",
    DELETE_HR_CHANGE_COMMENT_FAILURE: "DELETE_HR_CHANGE_COMMENT_FAILURE",
    DELETE_HR_CHANGE_COMMENT_FROM_ITEM_REQUEST: "DELETE_HR_CHANGE_COMMENT_FROM_ITEM_REQUEST",

    DELETE_HR_CHANGE_COMMENT_FROM_ITEM_SUCCESS: "DELETE_HR_CHANGE_COMMENT_FROM_ITEM_SUCCESS",
    DELETE_HR_CHANGE_COMMENT_FROM_ITEM_FAILURE: "DELETE_HR_CHANGE_COMMENT_FROM_ITEM_FAILURE",
    DELETE_CHANGE_REQUEST: "DELETE_CHANGE_REQUEST",

    SAVE_MANUAL_CHANGE_ON_HR_REPORT_REQUEST: "SAVE_MANUAL_CHANGE_ON_HR_REPORT_REQUEST",
    SAVE_MANUAL_CHANGE_ON_HR_REPORT_SUCCESS: "SAVE_MANUAL_CHANGE_ON_HR_REPORT_SUCCESS",
    SAVE_MANUAL_CHANGE_ON_HR_REPORT_FAILURE: "SAVE_MANUAL_CHANGE_ON_HR_REPORT_FAILURE",

    DELETE_CHANGE_SUCCESS: "DELETE_CHANGE_SUCCESS",
    DELETE_CHANGE_FAILURE: "DELETE_CHANGE_FAILURE",
    DELETE_CHANGED_FIELD_REQUEST: "DELETE_CHANGED_FIELD_REQUEST",

    DELETE_CHANGED_FIELD_SUCCESS: "DELETE_CHANGED_FIELD_SUCCESS",
    DELETE_CHANGED_FIELD_FAILURE: "DELETE_CHANGED_FIELD_FAILURE",
    DELETE_LEAVING_EMPLOYEE_REQUEST: "DELETE_LEAVING_EMPLOYEE_REQUEST",

    DELETE_LEAVING_EMPLOYEE_SUCCESS: "DELETE_LEAVING_EMPLOYEE_SUCCESS",
    DELETE_LEAVING_EMPLOYEE_FAILURE: "DELETE_LEAVING_EMPLOYEE_FAILURE",

    TOGGLE_NEW_INTEGRATION_MODAL: "TOGGLE_NEW_INTEGRATION_MODAL",
};
